import { render } from "./editReturnGoods.vue?vue&type=template&id=7b4baca7&scoped=true&ts=true"
import script from "./editReturnGoods.vue?vue&type=script&lang=ts"
export * from "./editReturnGoods.vue?vue&type=script&lang=ts"

import "./editReturnGoods.vue?vue&type=style&index=0&id=7b4baca7&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4baca7"]])

export default __exports__